export default __webpack_public_path__ + "static/media/aerial-test-2.974faf7a.jpg";